import axios from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { BASE_URL, MSAL_API_CLIENT_ID } from "./constants";
// TODO: Re-import when backend API scope is configured in Azure
// import { backendApiRequest } from "../authConfig";

const MSAL_INSTANCE_KEY = "__msalInstance";
 
export const setMsalInstance = (instance) => {
  window[MSAL_INSTANCE_KEY] = instance;
};

const getMsalInstance = () => window[MSAL_INSTANCE_KEY] ?? null;

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  async (config) => {
    const msalInstance = getMsalInstance();
    
    if (!msalInstance) {
      return config;
    }

    const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
    if (!account) {
      return config;
    }

    // TODO: Re-enable backend scope token acquisition once API scope is configured in Azure
    // Use stored token or ID token as fallback
    const storedToken = localStorage.getItem("backendAccessToken");
    if (storedToken) {
      config.headers.Authorization = `Bearer ${storedToken}`;
    } else {
      try {
        const response = await msalInstance.acquireTokenSilent({
          scopes: [`api://${MSAL_API_CLIENT_ID}/doorschedule-api-sso`],
          account,
        });
        config.headers.Authorization = `Bearer ${response.accessToken}`;
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          // Fallback to popup if silent token acquisition fails
          const response = await msalInstance.acquireTokenPopup({
            scopes: [`api://${MSAL_API_CLIENT_ID}/doorschedule-api-sso`],
          });
          config.headers.Authorization = `Bearer ${response.accessToken}`;
        }
        throw error;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;
